// eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
const Tabs = ({ children, ...props }: { children: any }) => (
  <ul
    className="cities-nearby__tabs text-xs flex flex-start mt-xl mb-sm"
    {...props}
  >
    {children}
  </ul>
);

export default Tabs;
